import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const UrticariaPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Urticaria</h1>
        <section className="mb-8">
          <p>Urticaria, also known as hives, is a skin condition characterized by red, itchy welts. Our natural therapies focus on reducing allergic reactions, soothing the skin, and preventing recurrence through herbal remedies and lifestyle changes.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Allergic reactions</li>
            <li>Stress</li>
            <li>Infections</li>
            <li>Certain foods or medications</li>
            <li>Environmental triggers</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Red, raised welts</li>
            <li>Itching</li>
            <li>Swelling</li>
            <li>Burning or stinging sensation</li>
            <li>Welts that change shape or location</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use anti-allergic herbs, skin-soothing remedies, and lifestyle modifications to naturally treat urticaria. Our approach focuses on reducing allergic reactions and preventing recurrence through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Reduces allergic reactions</li>
            <li>Soothes skin</li>
            <li>No harsh side effects</li>
            <li>Long-term relief</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Avoid known triggers</li>
            <li>Maintain good hygiene</li>
            <li>Manage stress</li>
            <li>Use gentle skincare products</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take to see improvement?</strong>
            <p>A: Many patients notice improvement within 1-2 weeks of consistent treatment.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for children?</strong>
            <p>A: Yes, our natural remedies are gentle and suitable for all age groups.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Can this treatment prevent recurrence?</strong>
            <p>A: Yes, our holistic approach helps prevent recurrence by addressing root causes.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from urticaria—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default UrticariaPage; 